import React from 'react';
import {connect} from 'react-redux';
import {getActivePicksTab} from 'selectors/ui';
import {getFavoritePicksCount} from 'selectors/favoritePicks';
import {getFollowingPicksCount} from 'selectors/followingPicks';
import {setActivePicksTab, FAVORITE_PICKS_TAB, FOLLOWING_PICKS_TAB} from 'actions/ui';

import './myPicksBar.scss';
import classnames from 'classnames';

const MyPicksBar = ({setActiveTab, activeTab, favoritePicksCount, followingPicksCount}) => (
  <nav className="sub-nav picks-nav">
    <button
      type="button"
      className={classnames({active: activeTab === FOLLOWING_PICKS_TAB})}
      onClick={() => setActiveTab(FOLLOWING_PICKS_TAB)}
    >
      Following ({followingPicksCount})
    </button>
    <button
      type="button"
      className={classnames({active: activeTab === FAVORITE_PICKS_TAB})}
      onClick={() => setActiveTab(FAVORITE_PICKS_TAB)}
    >
      Favorites ({favoritePicksCount})
    </button>
  </nav>
);

export default connect(
  state => ({
    activeTab: getActivePicksTab(state),
    favoritePicksCount: getFavoritePicksCount(state),
    followingPicksCount: getFollowingPicksCount(state),
  }),
  dispatch => ({
    setActiveTab: tab => dispatch(setActivePicksTab(tab)),
  }),
)(MyPicksBar);
